var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GuardGroups'
      }
    }
  }, [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("衛兵群組列表")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("衛兵群組列表")]), _c('div', {
    staticClass: "row d-flex justify-content-between align-items-center my-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 d-flex align-items-center"
  }, [_c('h6', {
    staticClass: "font-weight-bold flex-shrink-0 mb-0 mr-2"
  }, [_vm._v("群組狀態")]), _c('AppMultiSelect', {
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "input": _vm.fetchGuardGroupsFirstPage
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1), _c('div', {
    staticClass: "\n            col-12 col-xl-6\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center\n          "
  }, [_c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入衛兵群組名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuardGroupsFirstPage();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.fetchGuardGroupsFirstPage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('hr'), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("群組數目：" + _vm._s(_vm.groups.length) + " 個群組")]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.groups,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "head(count_guard_group)",
      fn: function fn() {
        return [_c('div', [_vm._v("衛兵回報"), _c('br'), _vm._v("人數")])];
      },
      proxy: true
    }, {
      key: "head(count_oa_group)",
      fn: function fn() {
        return [_c('div', [_vm._v("OA回報"), _c('br'), _vm._v("人數")])];
      },
      proxy: true
    }, {
      key: "head(count_admin)",
      fn: function fn() {
        return [_c('div', [_vm._v("管理員"), _c('br'), _vm._v("人數")])];
      },
      proxy: true
    }, {
      key: "head(count_healthy_guard)",
      fn: function fn() {
        return [_c('div', [_vm._v("連線"), _c('br'), _vm._v("衛兵數")])];
      },
      proxy: true
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.group_number) + " ")])];
      }
    }, {
      key: "cell(picture_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.picture_url,
            expression: "!!data.item.picture_url"
          }],
          attrs: {
            "rounded": "",
            "src": data.item.picture_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('i', {
          class: "fa fa-circle h2 text-".concat(_vm.statusEnum(data.item.status))
        })];
      }
    }, {
      key: "cell(team)",
      fn: function fn(data) {
        return [data.item.status != 0 ? _c('b-form-input', {
          attrs: {
            "type": "text",
            "readonly": ""
          },
          model: {
            value: data.item.team,
            callback: function callback($$v) {
              _vm.$set(data.item, "team", $$v);
            },
            expression: "data.item.team"
          }
        }) : _c('b-form-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: _vm.editTeam,
            callback: function callback($$v) {
              _vm.editTeam = $$v;
            },
            expression: "editTeam"
          }
        })];
      }
    }, {
      key: "cell(oa)",
      fn: function fn(data) {
        return [data.item.status == 0 ? _c('b-form-select', {
          attrs: {
            "options": _vm.oaGroups
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": ""
                }
              }, [_vm._v("-- 請選擇 --")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: data.item.oa_group_id,
            callback: function callback($$v) {
              _vm.$set(data.item, "oa_group_id", $$v);
            },
            expression: "data.item.oa_group_id"
          }
        }) : _c('b-form-select', {
          attrs: {
            "disabled": ""
          }
        }, [data.item.status == 2 ? _c('b-form-select-option', [_vm._v("黑名單")]) : _c('b-form-select-option', [_vm._v(_vm._s(data.item.oa_group_name))])], 1)];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [data.item.status == 0 ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary",
            "size": "md",
            "disabled": !data.item.oa_group_name && data.item.oa_group_id == ''
          },
          on: {
            "click": function click() {
              _vm.setOAGroup(data.item);
            }
          }
        }, [_vm._v(_vm._s(data.item.oa_group_name ? "確定更新" : "設定"))]) : _vm._e(), data.item.status != 0 ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "danger",
            "size": "md"
          },
          on: {
            "click": function click($event) {
              return _vm.handleReset(data.item);
            }
          }
        }, [_vm._v("重設")]) : _vm._e()];
      }
    }])
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }